import React, { useEffect, useState } from "react";
import {
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { getToken } from "../../../auth/authConfig";
import axios from "axios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import AuditPDFDocument from "./SummaryPDFDocument";

const AuditPDFGenerator = ({ formid, version, type,data }) => {
  const [auditData, setAuditData] = useState(data);
  const [loadingPage, setloading] = useState(true);
  const [version2, setVersion2] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setloading(true);
      const url = `${process.env.REACT_APP_SERVER_URL}/super/get_forms/pdfV2/${formid}`;

      try {
        const token = await getToken();
        const response = await axios.get(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
        if (response.status === 200) {
          if (response.data?.versionInfo?.length > 1) {
            setVersion2(true);
          }
          setAuditData(response.data);
          setloading(false);
        }
      } catch (e) {
        const status = e?.response?.status;
        // if (status === 401) {
        //   login();
        // }
        if (status === 500) {
          setError(true);
          setTimeout(() => {
            setError(false);
          }, 3000);
        }
        console.error("Error fetching data:", e);
      }
    };

    fetchData();
  }, []);

  if (loadingPage) {
    return (
      <div className="flex items-center justify-center">
        <SkeletonTheme baseColor="#d4d4d4" highlightColor="#f5f5f5">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div>
              <Skeleton
                style={{
                  height: "50px",
                  minWidth: "250px",
                }}
              />
            </div>
            {version === 2 && (
              <div>
                <Skeleton
                  style={{
                    height: "50px",
                    minWidth: "250px",
                  }}
                />
              </div>
            )}
          </div>
        </SkeletonTheme>
      </div>
    );
  }

  // console.log("auditData", auditData?.version[0]);

  return (
    <>
      <div style={{width:"100%"}} className="rounded-xl shadow-2xl p-2 text-center">
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent:"center",
              gap: "10px",
            }}
          >
            <div>
              <PDFDownloadLink
                document={<AuditPDFDocument data={auditData?.version[0]} />}
                // fileName={`Mars_Audit_Summary_V1.pdf`}
                fileName={`Mars_Audit_Summary_${formid}_V1.pdf`}

                className="w-full bg-green-700 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 inline-flex items-center justify-center space-x-2"
              >
                {({ loading }) =>
                  loadingPage ? (
                    <>
                     
                      <span>Generating PDF...</span>
                    </>
                  ) : (
                    <>
                     
                      <span>Download Summary For V1</span>
                    </>
                  )
                }
              </PDFDownloadLink>
            </div>

            {version2 && (
              <div>
                <PDFDownloadLink
                  document={<AuditPDFDocument data={auditData?.version[1]} />}
                  // fileName={`Mars_Audit_Summary_V2.pdf`}
                  fileName={`Mars_Audit_Summary_${formid}_V2.pdf`}

                  className="w-full bg-red-900 hover:bg-red-900 text-white  py-3 px-3 rounded-lg transition-colors duration-200 inline-flex items-center justify-center space-x-2"
                >
                  {({ loading }) => 
                    loadingPage ? (
                      <>
                       
                        <span>Generating PDF...</span>
                      </>
                    ) : (
                      <>
                       
                        <span>Download Summary For V2</span>
                      </>
                    )
                  }
                </PDFDownloadLink>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};

export default AuditPDFGenerator;
